import React, { useContext, useState } from 'react';
import Header from '../../template/Header';
import { Breadcrumbs, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AppContext from '../../state/AppContext';
import TopCollections from './components/TopCollections';
import Alerts from './components/Alerts';
import Metrics from './components/Metrics';
import HighFrequency from './components/HighFrequency';
import HighFrequencyAlertsDashboard from './components/HighFrequencyAlertsDashboard';
import Heatmap3d from './components/Heatmap3d';
import Heatmap2d from './components/Heatmap2d';
import Heatmap from './components/Heatmap';

const DashboardPage = () => {

    const { appContext } = useContext(AppContext);
    const project = appContext.project

    return (
        <div className="">
            <Header title="Project Dashboard"  >
                <Breadcrumbs aria-label="breadcrumb" separator="/" className="!text-gray-600" >
                    <Typography ><HomeOutlinedIcon className="text-gray-600" fontSize="small" /></Typography>
                    <Typography ><span className="text-gray-600">projects</span></Typography>
                    <Typography ><span className="text-gray-600">{project}</span></Typography>
                    <Typography ><span className="text-gray-600">Dashboard</span></Typography>
                </Breadcrumbs>
            </Header>
            <div className="content grid gap-8">
                <div className="layout grid gap-4">
                    <div className="flex justify-between items-center">
                        <h4 className="capitalize">
                            {project}
                        </h4>
                        {/* 
                        <div className="flex items-center gap-2">
                            <Tooltip title={isRunning ? "Stop" : "Start"} className="flex items-center">
                                <span className="text-gray-800">{isRunning ? "Stopped" : "Running"}</span>
                                <IconButton onClick={() => setIsRunning(!isRunning)}>
                                    {isRunning
                                        ? <StopCircleIcon className={isRunning ? "text-red-500 animate-pulse" : "text-red-500"} fontSize="large" />
                                        : <PlayCircleIcon className="text-green-500" fontSize="large" />}
                                </IconButton>
                            </Tooltip>
                        </div>*/}
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                        <div className="col-span-3">
                            <Metrics />
                        </div>
                        <div className="flex flex-col gap-4 col-span-2">
                            <Heatmap />
                            {/*<Heatmap2d /> */}
                            <Alerts />
                            <HighFrequencyAlertsDashboard />
                        </div>

                        <div className="flex flex-col gap-8">
                            <TopCollections />
                            <HighFrequency />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardPage;